import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { quickOrderSearchStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = mergeToNew(quickOrderSearchStyles.productSelector, {
    searchGridItem: {
        css: css`
            > ${IconWrapper} {
                top: 50%;
            }
        `,
    },
    searchDynamicDropdown: {
        cssOverrides: {
            selectedText: css`
                padding: 11px 16px;
            `,
        },
    },
});
